import { CommonModule } from '@angular/common';
import { Component, OnInit, forwardRef } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  NavController,
  NavParams,
  ToastController,
  ModalController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { format, isBefore, isEqual, parseISO } from 'date-fns';
import { ProverHorasComponent } from 'src/app/components/prover-horas/prover-horas.component';

@Component({
  selector: 'app-grupo-adm-horario-add',
  templateUrl: './grupo-adm-horario-add.page.html',
  styleUrls: ['./grupo-adm-horario-add.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ReactiveFormsModule,
    ProverHorasComponent
  ],
})
export class GrupoAdmHorarioAddPage implements OnInit {
  validations_form: FormGroup;
  diaSemanaList: any = [
    { id: 1, nome: this.translate.instant('Domingo') },
    { id: 2, nome: this.translate.instant('Segunda-Feira') },
    { id: 3, nome: this.translate.instant('Terça-Feira') },
    { id: 4, nome: this.translate.instant('Quarta-Feira') },
    { id: 5, nome: this.translate.instant('Quinta-Feira') },
    { id: 6, nome: this.translate.instant('Sexta-Feira') },
    { id: 7, nome: this.translate.instant('Sábado') },
  ];

  periodoList: any = [
    { id: 7, nome: '1 ' + this.translate.instant('Semana') },
    { id: 14, nome: '2 ' + this.translate.instant('Semana') },
    { id: 30, nome: '1 ' + this.translate.instant('Mês') },
  ];
  horaIni = format(new Date(), 'HH:mm');
  horaFim = format(new Date(), 'HH:mm');

  idHorario: any;
  idGrupo: any;
  horario: any = {};
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public grupoProvider: GrupoProvider,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.idHorario = this.navParams.get('id');
    this.idGrupo = this.navParams.get('idGrupo');
    this.horario = this.navParams.get('horario');

    this.validations_form = this.formBuilder.group({
      horarioInicio: new FormControl(this.horaIni, [
        Validators.required,
        Validators.maxLength(5),
        Validators.minLength(5),
      ]),
      horarioFim: new FormControl(this.horaFim, [
        Validators.required,
        Validators.maxLength(5),
        Validators.minLength(5),
      ]),
      diaSemana: new FormControl('', Validators.required),
      frequenciaDias: new FormControl('', Validators.required),
    });

    if (this.idHorario) {
      this.validations_form.controls['horarioInicio'].setValue(
        this.createHour(this.horario.horarioInicio)
      );
      this.validations_form.controls['horarioFim'].setValue(
        this.createHour(this.horario.horarioFim)
      );
      this.validations_form.controls['diaSemana'].setValue(
        this.horario.diaSemana
      );
      this.validations_form.controls['frequenciaDias'].setValue(
        this.horario.frequenciaDias
      );
    }
  }

  validation_messages = {
    horarioInicio: [
      { type: 'required', message: this.translate.instant('Campo Requirido') },
    ],
    horarioFim: [
      { type: 'required', message: this.translate.instant('Campo Requirido') },
    ],
    diaSemana: [
      { type: 'required', message: this.translate.instant('Campo Requirido') },
    ],
    frequenciaDias: [
      { type: 'required', message: this.translate.instant('Campo Requirido') },
    ],
  };

  async onSubmit(horario: {
    id: any;
    horarioInicio: string;
    horarioFim: string;
    idGrupo: any;
  }) {
    const inicio = new Date(`1970-01-01T${horario.horarioInicio}`);
    const fim = new Date(`1970-01-01T${horario.horarioFim}`);
    const result = isBefore(inicio, fim) || isEqual(inicio, fim);

    if (!result) {
      const toast = await this.toastCtrl.create({
        message: this.translate.instant("O hórario informado não atendem aos critérios de validação."),
        duration: 3000,
      });

      toast.present();
      return;
    }
    
    horario.id = this.idHorario || null;
    horario.horarioInicio = horario.horarioInicio.replace(/\D+/g, '');
    horario.horarioFim = horario.horarioFim.replace(/\D+/g, '');
    horario.idGrupo = this.idGrupo;
    this.grupoProvider.salvarHorario(horario).subscribe(async (data) => {
      let mensagem = '';
      if (this.idHorario) {
        mensagem = this.translate.instant('Dados atualizados com sucesso');
      } else {
        mensagem = this.translate.instant('Cadastro realizado com sucesso');
      }

      const toast = await this.toastCtrl.create({
        message: this.translate.instant(mensagem),
        duration: 3000,
      });
      toast.present();

      this.modalCtrl.dismiss(data);
    });
  }

  createHour(hour: string) {
    const horaStr = String(hour).padStart(4, '0');
    const horas = parseInt(horaStr.substring(0, 2), 10);
    const minutos = parseInt(horaStr.substring(2), 10);
    const date = new Date();
    date.setHours(horas, minutos, 0, 0);

    return format(date, 'HH:mm');
  }

  public closeModal() {
    this.modalCtrl.dismiss(false);
  }
}
